import { render } from "./OverlayModal.vue?vue&type=template&id=654631ef&scoped=true&ts=true"
import script from "./OverlayModal.vue?vue&type=script&lang=ts"
export * from "./OverlayModal.vue?vue&type=script&lang=ts"

import "./OverlayModal.vue?vue&type=style&index=0&id=654631ef&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654631ef"]])

export default __exports__